import { render, staticRenderFns } from "./ViewBikeDetails.vue?vue&type=template&id=227377e9&scoped=true&lang=pug&"
import script from "./ViewBikeDetails.vue?vue&type=script&lang=js&"
export * from "./ViewBikeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewBikeDetails.vue?vue&type=style&index=0&id=227377e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227377e9",
  null
  
)

export default component.exports